import Vue from 'vue'
// import 'es7-object-polyfill'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA77nW30WfQVJdDyeg-83TH9kqdPfBJGQw'
  }
})

Vue.component('GmapCluster', GmapCluster)
